export default __webpack_public_path__ + "static/media/nextcloud.4a50fc60.png";